/**
 * Pagination constants used across the application.
 * Centralized here to ensure consistency between components and tests.
 */

/**
 * Available page size options for paginated tables.
 * Used by GenericTable and all list pages (Cases, Calls, Campaigns, etc.)
 */
export const PAGE_SIZE_OPTIONS = [20, 50, 100] as const;

/**
 * Type representing valid page size values.
 * Derived from PAGE_SIZE_OPTIONS to ensure type safety.
 */
export type PageSize = (typeof PAGE_SIZE_OPTIONS)[number];

/**
 * Default page size for paginated tables.
 */
export const DEFAULT_PAGE_SIZE: PageSize = 20;

/**
 * Largest page the QC evaluations list will ask for (AQ-529). ListEvaluations
 * still serves 100, but a 100-row page makes the list scan and hydrate enough
 * evaluations to blow the request deadline on high-volume orgs, so the UI stops
 * offering it. Purely a client-side cap — the API is unchanged.
 */
export const EVALUATION_MAX_PAGE_SIZE = 50;

/**
 * Page size options for the QC evaluations list — PAGE_SIZE_OPTIONS minus the
 * sizes that are too slow to load (see EVALUATION_MAX_PAGE_SIZE).
 */
export const EVALUATION_PAGE_SIZE_OPTIONS = PAGE_SIZE_OPTIONS.filter(
  size => size <= EVALUATION_MAX_PAGE_SIZE,
);
